export const FOUR_OH_FOUR_TITLE = "Hmm, something's not right.";
export const FOUR_OH_FOUR_DESCRIPTION =
  "The page you're looking for no longer exists or has been moved.";
export const BACK_TO_HOME_PAGE = 'Back to Homepage';
